import React from 'react';
import { CheckIcon } from 'lucide-react';
import { volumes } from '../data/content';
export function Volumes() {
  return <section id="contenido" className="w-full bg-cream" data-id="element-256" data-mp="1lwbmfkvn4ntu">
      <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-24" data-id="element-257" data-mp="183vf47vpi3n4">
        <div className="max-w-3xl" data-id="element-258" data-mp="181sjn8bsbib0">
          <p className="font-display text-sm font-bold text-gold-deep" data-id="element-259" data-mp="1c4ywwzxbe9qz">
            Qué hay adentro
          </p>
          <h2 className="mt-3 font-display text-3xl font-black leading-tight text-ink sm:text-4xl lg:text-5xl" data-id="element-260" data-mp="1zut9rhhmvyb8">
            6 tomos, en el orden en que hay que resolverlo
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-261" data-mp="1quwgf2kaub9u">
            Del diagnóstico de tu situación actual al plan de los próximos 12
            meses. Cada tomo desarrolla una etapa y termina en una acción
            concreta.
          </p>
        </div>

        <ol className="mt-12 divide-y divide-line border-t border-line" data-id="element-262" data-mp="fhki177b6kv2">
          {volumes.map(volume => <li key={volume.number} className="grid gap-6 py-9 lg:grid-cols-[7rem_1fr_18rem] lg:gap-10" data-id="element-263" data-mp="kby8cv7461sv">
              <div className="flex items-baseline gap-3 lg:block" data-id="element-264" data-mp="3j93hcrog3m0m">
                <p className="font-display text-4xl font-black leading-none text-forest lg:text-5xl" data-id="element-265" data-mp="3jawos96vua9o">
                  {volume.number.toString().padStart(2, '0')}
                </p>
                <p className="text-xs font-semibold uppercase tracking-wide text-ink-muted lg:mt-2" data-id="element-266" data-mp="3t6glgxt9tczh">
                  Tomo {volume.number}
                </p>
              </div>

              <div data-id="element-267" data-mp="63bqo9bdi3em">
                <h3 className="font-display text-2xl font-extrabold leading-snug text-ink" data-id="element-268" data-mp="61s7a9uf7c8m">
                  {volume.title}
                </h3>
                <p className="mt-1 text-sm font-semibold text-gold-deep" data-id="element-269" data-mp="fsd3xrqja6ow">
                  {volume.subtitle}
                </p>
                <p className="mt-3 max-w-2xl text-base leading-relaxed text-ink-muted" data-id="element-270" data-mp="trcxndswlbrx">
                  {volume.description}
                </p>
              </div>

              <ul className="space-y-2 rounded-xl bg-white p-5" data-id="element-271" data-mp="wtr5n5zgfh2f">
                {volume.includes.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-ink" data-id="element-272" data-mp="11stxfoqfbqsg">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest" aria-hidden="true" data-id="element-273" data-mp="11qhizljvjyk5" />
                    {item}
                  </li>)}
              </ul>
            </li>)}
        </ol>

        <div className="mt-12 rounded-2xl bg-forest px-7 py-8 lg:px-10" data-id="element-274" data-mp="1bkq61tq4yzax">
          <h3 className="font-display text-xl font-extrabold text-cream" data-id="element-275" data-mp="1fjpa7c41ms1b">
            En todos los tomos encontrás
          </h3>
          <ul className="mt-5 grid gap-x-8 gap-y-3 text-sm text-cream/85 sm:grid-cols-2 lg:grid-cols-3" data-id="element-276" data-mp="1kl4xzbxlvcne">
            {['Explicaciones claras, sin tecnicismos', 'Ejemplos con números cercanos a tu realidad', 'Ejercicios y cuadros de trabajo', 'Errores frecuentes y cómo evitarlos', 'Acciones concretas al cierre de cada etapa', 'Formato PDF para leer o imprimir'].map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-277" data-mp="49sk5y56sqp">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-278" data-mp="2de9pe0nohmqb" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}